import React, { ReactElement, useState } from 'react';
import { Breadcrumbs, homeBreadcrumb, PageLoader } from 'slovlex-idsk-react-components';
import classNames from 'classnames';
import routes from '../../../../routing/routes';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../../context/PracovnyKrokLegislativnyMaterialContext';
import GlobalErrors from '../../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../../module/PageHeadingWithBackButton';
import { UlohyOrganizacie } from '../../../../module/LegislativnyMaterial/Ulohy';
import Layout from '../../../Layout';
import { pouzivalHasLegOrg } from '../../../../function/permissions';
import SecuredPage from '../../../../module/SecuredPage';
import { useUserContext } from '../../../../context/UserContext';
import { UserRoleEnum } from '../../../../model/currentuser/UserRole';
import SuccessMessages from '../../../../module/SuccessMessages';

const UlohyOrganizacieListPage = (): ReactElement => {
  const [pageStatus, setPageStatus] = useState<number>(null);
  const { pouzivatel } = useUserContext();
  const { loadingMaterial } = usePracovnyKrokLegislativnyMaterialContext();
  const classes: string = classNames(
    'ulohy-organizacie-list-page',
    loadingMaterial && 'slovlex-idsk-hidden',
  );

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: 'Úlohy organizácie',
          to: routes.ulohyOrganizacie.list,
        },
      ]}
      />
      <GlobalErrors />
      <PageLoader loading={loadingMaterial} />
      <SecuredPage
        allowForRoles={[UserRoleEnum.VEDUCI_ORGANIZACIE]}
        additionalCheck={pouzivalHasLegOrg(pouzivatel)}
        requestStatus={pageStatus}
      >
        <div className={classes}>
          <SuccessMessages />
          <PageHeadingWithBackButton heading="Úlohy organizácie" />
          <UlohyOrganizacie setPageStatus={setPageStatus} />
        </div>
      </SecuredPage>
    </Layout>
  );
};

export default UlohyOrganizacieListPage;
